import { BlockArchetype } from '../../../models/block';
import type { DashboardBlock, UserBlock } from '../../../models/block';
import { ConnectPreference } from '../../../models/suspectIdentificationBlockData';

export const normalizeText = (value: string = ''): string =>
  (value ?? '')
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, '-');

export const getBlockName = (block: DashboardBlock | UserBlock): string =>
  'name' in block ? block.name : block.block_name;

export const getBlockId = (block: DashboardBlock | UserBlock): string =>
  block.id;

export const getAssignedBy = (assignedBy: UserBlock['assigned_by']): string =>
  assignedBy?.full_name?.trim() || assignedBy?.display_name?.trim() || '--';

export const getBlockDescription = (block: DashboardBlock): string =>
  `${block.archetype ?? ''}`.trim();

export const isBlockActive = (block: UserBlock): boolean => !block.date_ended;

// A dashboard block is assignable if it's a goal or program archetype.
export const isAssignableBlock = (block: DashboardBlock): boolean =>
  block.archetype === BlockArchetype.Goal ||
  block.archetype === BlockArchetype.Program;

export const getRequestedNextStepLabel = (
  connectPreference: ConnectPreference | null
): string => {
  if (connectPreference === ConnectPreference.Book) return 'Meet with a coach';
  if (connectPreference === ConnectPreference.Chat) return 'Chat with a coach';
  if (connectPreference === ConnectPreference.Nothing) {
    return 'No additional support requested';
  }

  // This should never happen
  return '--';
};
